var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2142,
    viewBox: "0 0 1440 2142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.691406 60.0791C533.725 -14.3555 918.76 -12.3571 1439.31 60.0801C1502.54 68.8783 1550.2 107.052 1585.25 168.066C1620.39 229.23 1642.66 313.074 1654.83 412.26C1679.18 610.587 1662.96 868.571 1630.42 1124.69C1597.88 1380.71 1549.06 1634.52 1508.38 1824.34C1488.03 1919.24 1469.73 1998.14 1456.51 2053.3C1449.9 2080.89 1444.56 2102.54 1440.87 2117.29C1439.03 2124.66 1437.6 2130.31 1436.63 2134.12C1436.44 2134.86 1436.27 2135.53 1436.12 2136.13H3.85645C3.69794 2135.52 3.51988 2134.84 3.32422 2134.09C2.33287 2130.29 0.869142 2124.65 -1.01758 2117.28C-4.79102 2102.54 -10.2576 2080.92 -17.0264 2053.36C-30.5641 1998.25 -49.3099 1919.42 -70.1396 1824.59C-111.802 1634.93 -161.786 1381.32 -195.104 1125.42C-228.434 869.434 -245.036 611.524 -220.109 413.118C-207.644 313.895 -184.839 229.974 -148.861 168.681C-112.974 107.542 -64.1452 69.1331 0.691406 60.0791Z",
    fill: "white",
    stroke: "#108084",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArc);
export default __webpack_public_path__ + "static/media/arc.e802e89d8d0eb6643df221f1caa22259.svg";
export { ForwardRef as ReactComponent };